import { canEditPaymentMethod } from "@equidefi/shared";

export const getReturnTo = (step) => {
  const nextStep = step !== "PAYMENT" ? step : "ADDRESS";
  return String(nextStep).toLowerCase();
};

/**
 * `investment.next` can still read PAYMENT for a beat after a card or crypto
 * submission, because the event that advances it lands on a webhook. Routing the
 * investor back to a payment step they can no longer act on overrides the
 * processing page's hand-off and parks them on the "payment already started"
 * card. They still reach that card by opening the payment URL themselves.
 */
export const canRouteToStep = (step, investment) => {
  if (step !== "payment") return true;
  return canEditPaymentMethod(investment);
};
